import { combineEpics, ofType } from "redux-observable";
import {
    withLatestFrom,
    map,
    catchError,
    debounceTime,
    mergeMap,
    concatMap,
} from "rxjs/operators";
import { of, from, EMPTY } from "rxjs";
import * as motorService from "../../../../src/services/calculations/calculation-output/motor.service";
import * as motorActions from "../../../../src/store/calculation/calculation-output/motorSlice";
import * as tubingActions from "../../../../src/store/calculation/calculation-input/TubingSlice";
import { RootState } from "../../../../src/store/ConfigureStore";
import { MotorDto, MotorOilType_WARNINGDto } from "../../../store/model/calculations/motor";
import { setGasNotification } from "../../../store/calculation/calculation-output/gasCalculaionSlice";
import { setSurfaceCalculationComplete } from "../../../store/calculation/calculation-output/surfaceEquipmentSlice";

const GetMotorInput_HP_60 = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("tubing/setHiddenMotorAuto",
            "gasCalculation/setUseGasHandler",
            "gasCalculation/setNoOfSeparators",
            "pump/setPumpInputCalculated",
            "gasCalculation/setGasOutputGKXData",
            "protector/setProtectorCalculationComplete",
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.pump?.PumpInputCalculated)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.hPRating)),
            state$.pipe(map((state: RootState) => state?.motor?.MotorInput)),
            state$.pipe(map((state: RootState) => state?.pump?.SelectedPump)),
            state$.pipe(map((state: RootState) => state?.protector?.selectedLowerProtector)),
            state$.pipe(map((state: RootState) => state?.protector?.selectedUpperProtector))

        ),
        map(([actionData, tab1Input, tab3Input, PumpInputCalculated, BasicGasCalculation,
            GasCalculationOutPut, hPRating, MotorInput, selectedPump, selectedLowerProtector, selectedUpperProtector
        ]) => {
            let autoHpMotor = tab1Input?.hdnMotrAutoHP;
            var motorHP_60: Number = 0;
            let operatingFreq: string = tab3Input?.operatngFreq?.toString() ?? '';

            if (autoHpMotor == '1') {
                // let selectedPump = selectedPump?.totalBHP
                // var lwrHP = actionData[5]?.hp
                // var uprHP = actionData[6]?.hp
                let selectedPumpTotalBHP = selectedPump?.totalBHP ?? "0";
                var lwrHP = selectedLowerProtector?.hp;
                var uprHP = selectedUpperProtector?.hp;
                let pumpCalculated = PumpInputCalculated;
                let gasInput = BasicGasCalculation;
                let gasOutput = GasCalculationOutPut;
                //let GasCalculationCalculated = hPRating;

                var pmpTotBHP = '0'
                if (autoHpMotor?.toString() == '1') {
                    const pmpId = tab1Input?.hiddenPumpID;
                    if (pmpId != "" && selectedPumpTotalBHP) {
                        if (selectedPumpTotalBHP?.trim() != "") {
                            pmpTotBHP = pumpCalculated?.hPOPPump60Hz || "0";
                        }
                    }

                    let noOfGasSep = Number(gasInput?.noOfGasSeps);
                    let basicGasHP: string | null = "0";
                    let totbasicGasHP: number = 0;
                    const val1 = (isNaN(parseFloat(pmpTotBHP))) ? 0 : parseFloat(pmpTotBHP);
                    totbasicGasHP = val1;

                    if (noOfGasSep > 0) {
                        basicGasHP = hPRating?.toString();
                        const val2 = (isNaN(parseFloat(basicGasHP!))) ? 0 : parseFloat(basicGasHP!);

                        totbasicGasHP = (val2 * noOfGasSep) + val1;
                    }

                    let useOfChPmp = Number(gasInput?.useOfChgPmp);
                    let chPmpHP = "0";
                    if (useOfChPmp == 1) {
                        chPmpHP = gasOutput?.GKX_HPRating?.toString() || '0'
                        var chPmpVal = (isNaN(parseFloat(chPmpHP))) ? 0 : parseFloat(chPmpHP);
                        var opFreqval = parseFloat(operatingFreq);
                        var chPmpVal60 = ((chPmpVal * 60) / opFreqval).toFixed(1)
                        totbasicGasHP = totbasicGasHP + parseFloat(chPmpVal60);
                    }

                    if (lwrHP?.toString() !== "") {
                        var lwrHPVal = (isNaN(parseFloat(lwrHP?.toString()))) ? 0 : parseFloat(lwrHP?.toString());
                        totbasicGasHP = totbasicGasHP + lwrHPVal;

                    }
                    if (uprHP?.toString() !== "") {
                        var uprHPVal = (isNaN(parseFloat(uprHP?.toString()))) ? 0 : parseFloat(uprHP?.toString());
                        totbasicGasHP = totbasicGasHP + uprHPVal;
                    }
                    if (totbasicGasHP > 0) {
                        return Number(totbasicGasHP.toFixed(2));//
                    }
                    return 0;//
                }
            }
            else if (autoHpMotor == '0') {
                if (operatingFreq != "60") {
                    var mtrTotlhp = MotorInput?.motor_HPInput ?? 0;
                    var mtrval = (parseFloat(mtrTotlhp));
                    var opFreqval = parseFloat(operatingFreq);
                    if (opFreqval.toString() != "") {
                        var tot60Hzval2 = ((mtrval * 60) / opFreqval).toFixed(1);
                        motorHP_60 = Number(tot60Hzval2);//
                        return motorHP_60;
                    }
                }
            }
            return MotorInput?.motor_HPInput ?? 0;
        }),
        mergeMap(data => {
            return [
                motorActions.setMotorInputHP60(data)
            ]
        }),
    )
};

const GetMotorInput_HP = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("motor/setMotorInputHP60"
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.pump.PumpInputCalculated)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.hPRating)),
            state$.pipe(map((state: RootState) => state?.motor?.MotorInput)),
            state$.pipe(map((state: RootState) => state?.pump?.SelectedPump)),
            state$.pipe(map((state: RootState) => state?.protector?.selectedLowerProtector)),
            state$.pipe(map((state: RootState) => state?.protector?.selectedUpperProtector))
        ),
        map(([actionData, tab1Input, tab3Input, PumpInputCalculated, BasicGasCalculation,
            GasCalculationOutPut, hPRating, MotorInput, selectedPump, selectedLowerProtector, selectedUpperProtector
        ]) => {
            let autoHpMotor = tab1Input?.hdnMotrAutoHP;
            var motorHP: Number = 0;
            //let selectedPump = selectedPump?.totalBHP
            // var lwrHP = actionData[5]?.hp
            // var uprHP = actionData[6]?.hp
            let selectedPumpTotalBHP = selectedPump?.totalBHP ?? "0";
            var lwrHP = selectedLowerProtector?.hp;
            var uprHP = selectedUpperProtector?.hp;
            let pumpCalculated = PumpInputCalculated;
            let gasInput = BasicGasCalculation;
            let gasOutput = GasCalculationOutPut;
            //let GasCalculationCalculated = hPRating;

            if (autoHpMotor == '1') {
                var pmpTotBHP = '0'
                if (autoHpMotor?.toString() == '1') {
                    const pmpId = tab1Input?.hiddenPumpID;
                    if (pmpId != "" && selectedPumpTotalBHP) {
                        if (selectedPumpTotalBHP.trim() != "") {
                            pmpTotBHP = pumpCalculated?.hPOPPump || "0";
                        }
                    }

                    let noOfGasSep = +gasInput?.noOfGasSeps
                    let basicGasHP: string | null = "0";
                    let totbasicGasHP: number = 0;
                    const val1 = (isNaN(parseFloat(pmpTotBHP))) ? 0 : parseFloat(pmpTotBHP);
                    totbasicGasHP = val1;

                    if (noOfGasSep > 0) {
                        basicGasHP = hPRating?.toString()
                        const val2 = (isNaN(parseFloat(basicGasHP!))) ? 0 : parseFloat(basicGasHP!);

                        totbasicGasHP = (val2 * noOfGasSep) + val1;
                    }

                    let useOfChPmp = +gasInput?.useOfChgPmp
                    let chPmpHP = "0";
                    if (useOfChPmp == 1) {
                        chPmpHP = gasOutput?.GKX_HPRating?.toString() || '0'
                        var chPmpVal = (isNaN(parseFloat(chPmpHP))) ? 0 : parseFloat(chPmpHP);
                        totbasicGasHP = totbasicGasHP + chPmpVal;
                    }

                    if (lwrHP?.toString() !== "") {

                        var lwrHPVal = (isNaN(parseFloat(lwrHP?.toString()))) ? 0 : parseFloat(lwrHP?.toString());
                        totbasicGasHP = totbasicGasHP + lwrHPVal;

                    }
                    if (uprHP?.toString() !== "") {

                        var uprHPVal = (isNaN(parseFloat(uprHP?.toString()))) ? 0 : parseFloat(uprHP?.toString());
                        totbasicGasHP = totbasicGasHP + uprHPVal;
                    }

                    const ChPmpSelVal = gasInput?.useOfChgPmpNew?.toString()
                    if (ChPmpSelVal == "1") {

                        const chmp1Selctd = gasInput.chargePump?.toString()
                        const desrdStge1 = gasInput.chargePumpDesrdStge?.toString()

                        const chmp2Selctd = gasInput.chargePump2?.toString()
                        const desrdStg2 = gasInput.chargePumpDesrdStge2?.toString()
                        const chmp3Selctd = gasInput.chargePump3?.toString()
                        const desrdStg3 = gasInput.chargePumpDesrdStge3?.toString()

                        let chgPmp1: string | undefined = "0";
                        if ((chmp1Selctd != "") && (desrdStge1 != ""))
                            chgPmp1 = gasOutput?.CP1_HPRating?.toString()

                        let chgPmp2: string | undefined = "0";
                        if ((chmp2Selctd != "") && (desrdStg2 != ""))
                            chgPmp2 = gasOutput?.CP2_HPRating?.toString()

                        let chgPmp3: string | undefined = "0"
                        if ((chmp3Selctd != "") && (desrdStg3 != ""))
                            chgPmp3 = gasOutput?.CP3_HPRating?.toString()

                        const chgPmp1Val = (isNaN(parseFloat(chgPmp1!))) ? 0 : parseFloat(chgPmp1!);
                        const chgPmp2Val = (isNaN(parseFloat(chgPmp2!))) ? 0 : parseFloat(chgPmp2!);
                        const chgPmp3Val = (isNaN(parseFloat(chgPmp3!))) ? 0 : parseFloat(chgPmp3!);

                        totbasicGasHP = totbasicGasHP + (chgPmp1Val + chgPmp2Val + chgPmp3Val);
                    }
                    if (totbasicGasHP > 0) {
                        return Number(totbasicGasHP.toFixed(2));
                    }
                    return 0
                }
            }
            return MotorInput?.motor_HPInput?.toString() ?? ''
        }),
        mergeMap(data => {
            return [
                motorActions.setMotorInputHP(data)
            ]
        }),
    )
};

const loadMotorList = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "tubing/setCatalogType",
            "tubing/setHiddenMotorShowAll",
            "tubing/setHiddenMotorSeries",
            "motor/setMotorInputHP"
        ),
        debounceTime(500),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.motor?.MotorInput)),
            state$.pipe(map((state: RootState) => state?.motor?.motor_HPInput)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input?.catalogType)),
            state$.pipe(map((state: RootState) => state?.protector?.protectorCalculationComplete)),
        ),

        concatMap(([actionData, tab1Input, tab3Input, motorInput, motorHPInput, equipmentType, protectorCalculationComplete]) => {
            if (protectorCalculationComplete) {
                let motorSeries = ''
                let totalBHP = 0;
                if (tab3Input?.operatngFreq != 60) {
                    totalBHP = motorInput?.motor_HP60Input ?? 0
                }
                else {
                    totalBHP = motorHPInput ?? 0
                }

                let showAllMotors = (tab1Input?.hdnMotrShowAll == '1')
                const catalogFilter = equipmentType;

                const postData = [
                    tab1Input?.casingOD,
                    tab3Input?.bottomHoleTemp,
                    tab3Input?.unitBottomHoleTempListVal,
                    +totalBHP,
                    tab1Input?.unitSys,
                    showAllMotors?.toString(),
                    motorSeries = tab1Input?.hiddenMotrSers == "0" ? "" : tab1Input?.hiddenMotrSers,
                    catalogFilter
                ];

                return from(motorService.GetMotorList(postData)).pipe(
                    map((data) => motorActions.setMotorList(data)),
                    catchError(() => of(console.error("Failed to load motor data")))
                );
            }

            return EMPTY;
        })
    );
};

const SetSelectedMotor = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("motor/setMotorList"
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.motor?.MotorList))
        ),
        mergeMap(([actionData, tab1Input, motorList]) => {
            var motors: MotorDto[] = motorList;
            var selectedMotor = motors?.find(x => x?.id == tab1Input?.hiddenMotrID);
            if (selectedMotor?.id !== undefined && selectedMotor?.id !== "") {
                return of(motorActions.setSelectedMotor(selectedMotor));
            }
            return EMPTY;
        })
    )
};

const loadMotorPerformanceList = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "motor/setSelectedMotor",
            "motor/setMotorLoadInput",
        ),
        debounceTime(500),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.motor?.MotorInput)),
            state$.pipe(map((state: RootState) => state?.motor?.SelectedMotor)),
            state$.pipe(map((state: RootState) => state?.motor?.motor_HPInput)),
        ),
        concatMap(([actionData, tab1Input, tab3Input, motorInput, selectedMotor, motorHPInput]) => {
            const bottmWhole = tab3Input?.bottomHoleTemp;
            const bottmWholeUnit = tab3Input?.unitBottomHoleTempListVal;
            const motorid = selectedMotor?.id;
            const unitSys = tab1Input?.unitSys;
            const motorLoad = motorInput?.motorLoad;
            const inputData = [motorid, unitSys, bottmWhole, bottmWholeUnit, motorLoad];
            const hpReq = motorHPInput;
            const opFreq = tab3Input?.operatngFreq?.toString();

            return from(motorService.GetMotorIteration(inputData, hpReq, opFreq)).pipe(
                map(data => {
                    if (!motorid) {
                        setSurfaceCalculationComplete(false);
                        tubingActions.resetHiddenMotorID();
                    }
                    return data;
                }),
                mergeMap(data => {
                    if (data?.length > 0) {
                        return [
                            motorActions.setMotorPerformanceData(data),
                            motorActions.setMotorDeRatingAmps(data[0].motorCurrent),
                            motorActions.setMotorDeRatingHp( data[0].motorHP),
                            motorActions.setMotorDeRatingVolts(data[0].motorVoltage)
                        ]
                    }
                    return EMPTY;
                }
                ));
        })
    );

};

const getMotorOilWarning = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "motor/setMotorPerformanceData",
            "tubing/setHiddenProtectorOilType",
        ),
        debounceTime(500),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input))
        ),
        concatMap(([actionData, tab1Input]) => {
            const mtrOilTyp = tab1Input?.hdnProtector_OilType ?? "0";
            var unitSys = tab1Input?.unitSys;
            var postData = [mtrOilTyp, unitSys];
            return from(motorService.getMtrOilTempChk(postData)).pipe(
                mergeMap(data => {
                    var motorOilVal: MotorOilType_WARNINGDto = { MinTemp: 0, MaxTemp: 0 };
                    motorOilVal.MinTemp = data?.[0];
                    motorOilVal.MaxTemp = data?.[1];
                    return [
                        motorActions.setMotorOilWarning(motorOilVal)
                    ]
                }
                ));
        })
    );
};

const loadMotorCalculations = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "motor/setSelectedMotor",
            "tubing/setCatalogType"
        ),
        debounceTime(500),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
            state$.pipe(map((state: RootState) => state?.motor?.SelectedMotor))
        ),
        concatMap(([actionData, tab1Input, gasOutput, selectedMotor]) => {
            if (selectedMotor) {
                const motrOD = selectedMotor?.motorOD?.toString() ?? '';
                const unitSys = tab1Input?.unitSys?.toString();
                const liqVolRate = gasOutput?.Intake_VolumeOfOil?.toString() == null ? "0" : gasOutput?.Intake_VolumeOfOil?.toString();
                const watrVolm = gasOutput?.Intake_VolumeOfWater?.toString() == null ? "0" : gasOutput?.Intake_VolumeOfWater?.toString();
                const casingId = tab1Input?.casingID ? tab1Input?.casingID?.toString() : tab1Input?.casingID?.toString();
                const casingIdUnit = tab1Input?.unitCasingIDListVal;
                const casingOD = tab1Input?.casingOD?.toString() ?? '';
                const shrdOD = tab1Input?.hiddenMotrShrdOD == null ? "0" : tab1Input?.hiddenMotrShrdOD?.toString();
                const MtrID = selectedMotor?.id ?? '';
                const ShroudFlag = "false";
                const catalogFilter = +tab1Input?.catalogType;

                return from(motorService.GetMotorCalculation(liqVolRate, casingId, casingIdUnit, motrOD, unitSys, casingOD, ShroudFlag, shrdOD, watrVolm, MtrID, catalogFilter)).pipe(
                    mergeMap(data => {
                        const formattedODList = Object.keys(data?.shroudODList).map(
                            (key: any) => ({
                                id: data?.shroudODList[key],
                                name: key,
                            })
                        );

                        return [
                            motorActions.setFluidVelocity(data?.fluidVelocity),
                            motorActions.setShroudODList(formattedODList),
                            motorActions.setMotorSensorList(data?.mtrSensorList),
                            motorActions.setMotorCalculationComplete(true)
                        ]
                    }
                    ));
            }
            return of(motorActions.setMotorCalculationComplete(true))
        })
    );
};

const loadShroudWeightList = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "tubing/setHiddenMotorSharedOD",
            "motor/setShroudODList",// to be checked
        ),
        debounceTime(500),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input))
        ),
        concatMap(([actionData, tab1Input]) => {
            const casingOD = tab1Input?.hiddenMotrShrdOD?.toString();
            const unitSys = tab1Input?.unitSys?.toString();

            return from(motorService.GetShroudWeight(casingOD, unitSys)).pipe(
                mergeMap(data => {
                    const formattedWTList = Object.keys(data?.CasingWeightList)
                        .sort((a, b) => parseFloat(a) - parseFloat(b))
                        .map(
                            (key: any) => ({
                                id: data?.CasingWeightList[key],
                                name: key,
                            })
                        );
                    return [
                        motorActions.setShroudWeightList(formattedWTList)
                    ]
                }
                ));

        })
    );
};

const calculateShroudFluidVelocity = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "tubing/setHiddenMotorShrdWt",
            "motor/setShroudWeightList"
        ),
        debounceTime(500),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.motor?.MotorInput)),
            state$.pipe(map((state: RootState) => state?.gasCalculations)),
            state$.pipe(map((state: RootState) => state?.motor?.SelectedMotor))
        ),
        concatMap(([actionData, tab1Input, MotorInput, gasOutput, selectedMotor]) => {
            const currentAmp = selectedMotor?.current;
            const sizeHP = selectedMotor?.size;
            const liqVolRate = gasOutput?.GasCalculationOutPut?.Intake_VolumeOfOil?.toString() == null ? "0" : gasOutput?.GasCalculationOutPut?.Intake_VolumeOfOil?.toString();
            const watrVolm = gasOutput?.GasCalculationOutPut?.Intake_VolumeOfWater?.toString() == null ? "0" : gasOutput?.GasCalculationOutPut?.Intake_VolumeOfWater?.toString();
            const HPReqd = MotorInput?.motor_HPInput;
            const casingId = tab1Input?.casingID?.toString();
            const casingIdUnit = tab1Input?.unitCasingIDListVal;
            const unitSys = tab1Input?.unitSys?.toString();
            const shroudWt = tab1Input?.hiddenMotrShrdWght;
            const mtrODLd = selectedMotor?.motorOD;
            const shrodOD = tab1Input?.hiddenMotrShrdOD;
            const postData = [HPReqd, sizeHP, currentAmp, liqVolRate, casingId, casingIdUnit, shrodOD, unitSys, mtrODLd, shroudWt, watrVolm];

            return from(motorService.GetShroudFluidVelocityPostMotor(postData)).pipe(
                mergeMap(data => {
                    return [
                        motorActions.setFluidVelocityPostMotor(data)
                    ]
                }
                ));

        })
    );
};

const loadMotorPerformancePlotData = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "motor/setMotorPerformanceData"
        ),
        debounceTime(500),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.motor?.MotorInput)),
            state$.pipe(map((state: RootState) => state?.motor?.SelectedMotor)),
            state$.pipe(map((state: RootState) => state?.motor?.MotorperformanceList))
        ),
        concatMap(([actionData, MotorInput, selectedMotor, motorPerformance]) => {
            const motorId = selectedMotor?.id;
            //const targetMotorLoad = MotorInput?.motorLoad ?? 0;
            const targetMotorLoad = motorPerformance[0]?.motorLoad ?? 0;
            //const targetMotorLoad = 2517;
            if (motorId) {
                return from(motorService.GetMotorPerformancePlotData(motorId, targetMotorLoad)).pipe(
                    mergeMap(data => {
                        return [
                            motorActions.setMotorPerformancePlotData(data)
                        ]
                    }
                    ));
            }
            return EMPTY;
        })
    );
};

const fetchMotorEquipments = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "motor/setMotorPerformanceData"
            // "motor/fetchEquiment"
        ),
        debounceTime(500),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.motor?.SelectedMotor)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
        ),
        concatMap(([actionData, selectedMotor, tab1Input]) => {
            if (selectedMotor?.series === undefined || selectedMotor?.series === null) {
                return EMPTY;
            } else {
                return from(motorService.fetchEquipments(selectedMotor?.series, tab1Input?.catalogType)).pipe(
                    mergeMap(data => {
                        if (data.length === 0) {
                            return [
                                setGasNotification({
                                    show: true,
                                    message: "There are no co-related Equipments for the selected Motor",
                                    type: "info",
                                }),
                                motorActions.setEquipmentsForMotor(data)
                            ]
                        }
                        else {
                            return [
                                motorActions.setEquipmentsForMotor(data)
                            ]
                        }
                    }
                    ));
            }
        })
    );
};
export const motorEpic = combineEpics(
    loadMotorList,
    GetMotorInput_HP,
    GetMotorInput_HP_60,
    SetSelectedMotor,
    loadMotorPerformanceList,
    loadMotorCalculations,
    loadShroudWeightList,
    calculateShroudFluidVelocity,
    loadMotorPerformancePlotData,
    fetchMotorEquipments,
    getMotorOilWarning
);
